module.exports = __webpack_public_path__ + "img/covers-04.f4d3570b.png";